import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Icon } from '../../../common/html/icon'
import { COMPANY_INFO_KEYS, TREE_AGE_OPTIONS } from './constants'

export const BlockTreeAge = ({ data, isDomesticSearch }) => {
  const { YEARS_OF_OPERATION, YEAR_OF_OPERATION } = COMPANY_INFO_KEYS
  const key = isDomesticSearch ? YEARS_OF_OPERATION : YEAR_OF_OPERATION

  const isTreeActive = (item) => {
    if (!data) {
      return !item.minAge
    }

    if (data[key] === undefined) return false

    if (
      data[key] > item.maxAge &&
      item.minAge === item.maxAge &&
      item.minAge > 0
    )
      return true

    return item.minAge <= data[key] && item.maxAge >= data[key]
  }

  return (
    <div className="dFlex alignItemsEnd justifyContentBetween mb3">
      {TREE_AGE_OPTIONS.map((item) => (
        <Element
          key={item.label}
          elementName="div"
          className="flexColumn alignItemsCenter justifyContentCenter"
          style={{ color: isTreeActive(item) ? '#3DA967' : '#9C9C9C' }}
        >
          <Icon className={item.icon} style={item.style} />
          <span className="mt1">
            <Translate value={item.label} />
          </span>
        </Element>
      ))}
    </div>
  )
}
